import React from 'react'

import { MediaBoxEmptyRow } from '../../Components'

export const MediaBox = props => {
    const { title, description, emptyText } = props;

    return (
        <div className="my-3">
            <h6 className="border-bottom border-gray pb-2 mb-0">{title} {description && <small className="d-block text-muted">{description}</small>}</h6>
            {props.children ? 
                props.children                
            :
                <MediaBoxEmptyRow text={emptyText}></MediaBoxEmptyRow>
            }
            {/* <small className="d-block text-right mt-3">
            <a href="/#">All updates</a>
        </small> */}
        </div>
    );
}